import useWebSocket from "react-use-websocket";
import { handleLogout } from "../App/store/features/auth/authSlice";
import { BASE_API_V2_WSS_URL, BASE_SOCKET_URI } from "./constant";
import { successToast } from "./toastHelper";

let ws;
export const connectSocket = dispatch => {
  try {
    const authToken = localStorage.getItem("accessToken");
    const chatbotUrl = `${BASE_SOCKET_URI}?access_token=${authToken}`;
    if (ws) ws.close();
    ws = new WebSocket(chatbotUrl);
    ws.addEventListener("open", () => {
      ws.send('{"protocol": "json","version": 1}');
    });
    ws.addEventListener("message", event => {
      const eventString = event.data.split("")[0];
      const receivedMessage = JSON.parse(eventString);
      if (receivedMessage?.target === "ReceivePermissionUpdate") {
        dispatch(handleLogout());
      }
    });
    ws.addEventListener("close", () => {
      console.log("WebSocket connection closed");
    });
  } catch (error) {
    console.log("Error in connecting to WebSocket", error);
  }
};

export const useProjectImportUpdatesSocket = () => {
  const onMessage = ({ data }) => {
    const { messageType, content } = JSON.parse(data);
    successToast(content);
  };

  const authToken = localStorage.getItem("accessToken");
  const socketUrl = `${BASE_API_V2_WSS_URL}?access_token=${authToken}`;
  const socket = useWebSocket(socketUrl, {
    onOpen: () => {
      console.log("WebSocket connection established.");
    },
    share: true,
    filter: () => false,
    retryOnError: true,
    onMessage: onMessage,
    shouldReconnect: () => true,
    onError: e => console.log(e),
    heartbeat: {
      message: "ping",
      returnMessage: "pong",
      timeout: 6000,
      interval: 30 * 1000
    }
  });

  return socket;
};
